export default "__VITE_ASSET__BSeQ4tO3__"